import React, {useEffect, useMemo, useState} from "react";
import {Col, Row} from "react-bootstrap";
import TextArea from "../../../common/TextArea";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import EditableTable from '../../../primer/Editable-Table';
import Dropdown from "../../../primer/Dropdown";
import {useDispatch, useSelector} from "react-redux";
import {setSaveNewProductMovements} from "../../../../_reducers/activitySlice";
import {fetchAdvancedTypes, fetchProducts} from "../../../../_apis/api";
import {
    getDefaultOptionByValue,
    getGreekCurrencyFormat,
    getModeByInstallation,
    getNumberByInstallation,
    getOptionsByData,
    getPreNumberByInstallation,
    getSelectedInstallation,
    getSelectedPreNumbers,
    isEmpty,
    removeDuplicateObjects
} from "../../../../_helpers/commonFunctions";
import {
    setNewProductMovements,
} from "../../../../_reducers/DataPanel/Products/productsSlice";
import {
    getLabelByValue,
    getObjectFromArrayOfObjects
} from "../../../../_helpers/helperFunctions";
import {preNumberGreek} from "../../../../_data/settings/advanced-types-search";
import axios from "axios";
import {
    getSalesTotals,
} from "../../../../_helpers/product-sales-calculations";
import {measurementUnitsData} from "../../../../_data/mydata/measurementUnits";
import {useTranslation} from "../../../../hooks/useTranslation";

export const ProductMovementsGeneral = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const PRODUCTS_DATA = useSelector((state) => state.PRODUCTS_DATA);
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const company = useSelector(state => state.COMPANY_DATA.company);
    const [productsList, setProductsList] = useState([]);
    const installations = useSelector((state) => state.COMPANY_DATA.companyInstallations);
    const [docIsCensus, setDocIsCensus] = useState(false);
    const [incrKey, setIncrKey] = useState(0);

    let possibleInnerMovements = [];
    if (installations.length > 0) {
        installations.forEach((inst) => {
            possibleInnerMovements.push({
                value: inst.installationMasterId,
                label: inst.type + " " + inst.address + " " + inst.city,
            })
        })
    }

    const productCodeColumns = [
        {
            label: t('ProductsMovementsNew.smallTable.code'),
            name: "code",
        },
        {
            label: t('ProductsMovementsNew.smallTable.productName'),
            name: "name",
        },
        {
            label: t('ProductsMovementsNew.smallTable.alternativeName'),
            name: "alternateName",
        },
    ];

    const productMovementColumns = [
        {
            name: "No",
            field: "no",
            editable: false,
        },
        {
            name: t('ProductsMovementsNew.table.productCode'),
            field: "code",
            editable: true,
            inputType: {
                config: {
                    onChangeSearchCell: (_, keyword, setData) => loadProductListData(keyword, setData),
                    excludeColumns: [],
                    columns: productCodeColumns,
                    data: productsList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: t('ProductsMovementsNew.table.productCodePlaceholder')
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: t('ProductsMovementsNew.table.productName'),
            field: "name",
            editable: true,
            inputType: {
                config: {
                    onChangeSearchCell: (_, keyword, setData) => loadProductListData(keyword, setData),
                    excludeColumns: [],
                    columns: productCodeColumns,
                    data: productsList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: t('ProductsMovementsNew.table.productNamePlaceholder')
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: t('ProductsMovementsNew.table.mu'),
            field: 'muLabel',
            editable: false,
        },
        {
            name: t('ProductsMovementsNew.table.quantity'),
            field: 'quantity',
            editable: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "nosuffix",
                    maxLength: 10
                }
            }
        },
        {
            name: t('SalesNew.productTable.vat'),
            field: "vatPercentage",
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('SalesNew.productTable.netValue'),
            field: "netValue",
            editable: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7
                }
            }
        },
        {
            name: t('SalesNew.productTable.vatValue'),
            field: "vat",
            editable: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7
                }
            }
        },
        {
            name: t('SalesNew.productTable.totalValue'),
            field: "totalValue",
            editable: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7
                }
            }
        },
    ];

    const requestData = {
        company: company.id,
        year: company.year.toString(),
    }
    // Options for Document Type Dropdown
    const allDocumentTypes = SETTINGS.settings.advancedTypes;
    const clientMovemnetDT = getObjectFromArrayOfObjects(allDocumentTypes, 'Product Movements', 'section');
    const documentTypesOptions = getOptionsByData(clientMovemnetDT, '_id', 'name')
    const [preNumberGreekOptions, setPreNumberGreekOptions] = useState([]);
    let selectedDocumentTypeData = [];
    let dtInstallationsOptions = [];
    let disabledFields = false;
    if (PRODUCTS_DATA.newProductMovements.documentType === undefined || PRODUCTS_DATA.newProductMovements.documentType === '') {
        disabledFields = true;
    } else {
        let dtData = getObjectFromArrayOfObjects(clientMovemnetDT, PRODUCTS_DATA.newProductMovements.documentType, '_id');
        if (dtData.length > 0) {
            selectedDocumentTypeData = dtData['0'];
            dtInstallationsOptions = getOptionsByData(selectedDocumentTypeData['documentNumbering'], "installationMasterId", "installation");
            dtInstallationsOptions = removeDuplicateObjects(dtInstallationsOptions, 'value');
        }
    }

    const loadProductListData = (keyword, setData) => {
        const reqData = {
            isProductMovement: "true",
            company: company.id
        }
        if (keyword) reqData.name = keyword;
        axios.get(process.env.REACT_APP_API_URL2 + `/sale/product-list-by-advanced-type-id`, {
            headers: { "Content-Type": "application/json" },
            params: reqData
        }).then(res => {
            if (res.data && res.data.status === '200') {
                if (res.data.data) {
                    setData(res.data.data);
                } else {
                    setData([]);
                }
            } else {
                setData([]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const handleOnChange = async (e, type = "default", ddname = '') => {
        // Set if editing the form
        if (!ACTIVITY.saveNewProductMovements) {
            dispatch(setSaveNewProductMovements(true));
        }
        let name;
        let value;
        if (type === 'dd' || type === 'ac') {
            value = e.value;
            name = ddname;
        } else if (type === 'dp') {
            value = e;
            name = ddname;
        } else {
            value = e.target.value;
            name = e.target.name;
        }
        let productData = Object.assign({}, PRODUCTS_DATA);
        let newProductMovementData = {};
        newProductMovementData[name] = value;
        if (name === 'documentType') {
            newProductMovementData.documentTypeName = getLabelByValue(documentTypesOptions, value, 'value');
            let dtData = getObjectFromArrayOfObjects(clientMovemnetDT, value, '_id');
            if (dtData.length > 0) {
                if (dtData['0']?.isCensus === "active") {
                    setDocIsCensus(true);
                    newProductMovementData.innerMovement = "";
                } else {
                    setDocIsCensus(false);
                }
                selectedDocumentTypeData = dtData['0'];
                let selectedInstallation = getSelectedInstallation(selectedDocumentTypeData["documentNumbering"]);
                if (Object.keys(selectedInstallation).length > 0) {
                    newProductMovementData.installation = selectedInstallation.installationMasterId;
                    newProductMovementData.preNumber = selectedInstallation.preNumber;
                    newProductMovementData.number = selectedInstallation.number + 1;
                    newProductMovementData.installationMode = selectedInstallation.numberingMode;
                    newProductMovementData.numberingMode = selectedInstallation.numberingMode;
                    let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, newProductMovementData.installation);
                    setPreNumberGreekOptions(newPreNumbers);
                }
            } else {
                newProductMovementData.installation = "";
                newProductMovementData.preNumber = "";
                newProductMovementData.number = "";
                newProductMovementData.installationMode = "";
            }
        }
        // Update Installation Field Values on Change
        if (name === 'installation') {
            if (productData.newProductMovements?.innerMovement) {
                if (productData.newProductMovements?.innerMovement === value) {
                    newProductMovementData.innerMovement = "";
                }
            }
            newProductMovementData.installationName = getLabelByValue(dtInstallationsOptions, value, 'value');
            newProductMovementData.preNumber = getPreNumberByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
            newProductMovementData.installationMode = getModeByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
            newProductMovementData.numberingMode = getModeByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
            newProductMovementData.number = getNumberByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId') + 1;
            // This will pre number given in document number table
            let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, value);
            setPreNumberGreekOptions(newPreNumbers);
        }
        dispatch(setNewProductMovements({...productData.newProductMovements, ...newProductMovementData}));
    }

    useEffect(() => {
        dispatch(fetchProducts(requestData))
        dispatch(fetchAdvancedTypes(requestData))
        const productQuantitySum = getSumOfDataValues(PRODUCTS_DATA.newProductMovements.products, 'quantity');
        dispatch(setNewProductMovements({...PRODUCTS_DATA.newProductMovements, sum: productQuantitySum}));
    }, [])

    useEffect(() => {
        if (PRODUCTS_DATA.newProductMovements.installation !== undefined && PRODUCTS_DATA.newProductMovements.installation !== '') {
            let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, PRODUCTS_DATA.newProductMovements.installation);
            setPreNumberGreekOptions(newPreNumbers);
        }
    }, []);

    useEffect(() => {
        loadProductListData(null, setProductsList);
    }, [])

    const getSumOfDataValues = (data, field = 'sum') => {
        let sum = 0;
        if (data && data.length > 0) {
            data.forEach(item => {
                sum += +item[field] || 0;
            })
        }
        return +Number(sum).toFixed(2);
    }

    const parentMydataActions = {
        insert: (e, data) => {
            if (e.key === "Enter") return;
            if (!ACTIVITY.saveNewProductMovements) dispatch(setSaveNewProductMovements(true));

            if (["name", "code"].includes(data.field)) {
                let cloneProducts = structuredClone(PRODUCTS_DATA.newProductMovements.products);
                const productData = e.row;
                cloneProducts.push({
                    _id: productData._id,
                    no: String(cloneProducts.length + 1),
                    id: String(cloneProducts.length + 1),
                    pid: productData._id,
                    name: productData.name,
                    code: productData.code,
                    mu: productData.measurementUnit,
                    muLabel: measurementUnitsData.find((el) => el.id === String(productData.measurementUnit)).name,
                    quantity: 1,
                    netValue: 0,
                    vat: 0,
                    totalValue: 0,
                    vatPercentage: isNaN(+productData.vat) ? 0 : +productData.vat,
                });
                dispatch(setNewProductMovements({
                    ...PRODUCTS_DATA.newProductMovements,
                    products: cloneProducts,
                    sum: getSumOfDataValues(cloneProducts, 'quantity'),
                    totalQuantity: getSumOfDataValues(cloneProducts, 'quantity'),
                    totalNetValue: getSumOfDataValues(cloneProducts, 'netValue'),
                    totalVatValue: getSumOfDataValues(cloneProducts, 'vat'),
                    totalAmount: getSumOfDataValues(cloneProducts, "totalValue"),
                }));
            }
        },
        update: (data, id, rowIndex, e) => {
            if (e.key === "Enter") return;
            if (!ACTIVITY.saveNewProductMovements) dispatch(setSaveNewProductMovements(true));
            const cloneProducts = structuredClone(PRODUCTS_DATA.newProductMovements.products);
            let findMatching = cloneProducts[rowIndex];

            if (e?.row) { // Its product advanced combo box
                const productData = e.row;
                findMatching._id = productData._id;
                findMatching.pid = productData._id;
                findMatching.name = productData.name;
                findMatching.code = productData.code;
                findMatching.mu = productData.measurementUnit;
                findMatching.muLabel = measurementUnitsData.find((el) => el.id === String(productData.measurementUnit)).name;
                findMatching.vatPercentage = isNaN(+productData.vat) ? 0 : +productData.vat;
            } else {
                if (!isEmpty(data.netValue)) {
                    findMatching.netValue = +Number(data.netValue).toFixed(3);
                    findMatching.vat = +Number((findMatching.vatPercentage) / 100 * +findMatching.netValue).toFixed(2);
                    findMatching.totalValue = +Number(+findMatching.netValue + +findMatching.vat).toFixed(2);
                } else if (!isEmpty(data.totalValue)) {
                    if (findMatching.vatPercentage === 0) {
                        findMatching.totalValue = +Number(data.totalValue).toFixed(2);
                        findMatching.netValue = findMatching.totalValue;
                        findMatching.vat = 0;
                    } else {
                        findMatching.netValue = +Number(+data.totalValue / (1 + (+findMatching.vatPercentage / 100))).toFixed(2);
                        findMatching.vat = +Number(+data.totalValue - findMatching.netValue).toFixed(2);
                        findMatching.totalValue = +Number(findMatching.netValue + findMatching.vat).toFixed(2);
                    }
                } else if (!isEmpty(data.quantity)) {
                    findMatching.quantity = +Number(data.quantity).toFixed(2);
                }
            }

            dispatch(setNewProductMovements({
                ...PRODUCTS_DATA.newProductMovements,
                products: cloneProducts,
                sum: getSumOfDataValues(cloneProducts, 'quantity'),
                totalQuantity: getSumOfDataValues(cloneProducts, 'quantity'),
                totalNetValue: getSumOfDataValues(cloneProducts, 'netValue'),
                totalVatValue: getSumOfDataValues(cloneProducts, 'vat'),
                totalAmount: getSumOfDataValues(cloneProducts, "totalValue"),
            }));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!ACTIVITY.saveNewProductMovements) dispatch(setSaveNewProductMovements(true));

            const cloneProducts = structuredClone(PRODUCTS_DATA.newProductMovements.products);
            cloneProducts.splice(rowIndex, 1);
            cloneProducts.forEach((row, idx) => {
                row.no = String(idx + 1);
                row.id = String(idx + 1);
            })
            dispatch(setNewProductMovements({
                ...PRODUCTS_DATA.newProductMovements,
                products: cloneProducts,
                sum: getSumOfDataValues(cloneProducts, 'quantity'),
                totalQuantity: getSumOfDataValues(cloneProducts, 'quantity'),
                totalNetValue: getSumOfDataValues(cloneProducts, 'netValue'),
                totalVatValue: getSumOfDataValues(cloneProducts, 'vat'),
                totalAmount: getSumOfDataValues(cloneProducts, "totalValue"),
            }));
        }
    }
    let productMovementsTableData = PRODUCTS_DATA.newProductMovements.products;
    const selectedDocumentType = getDefaultOptionByValue(documentTypesOptions, PRODUCTS_DATA.newProductMovements.documentType, 'value', 'label', 'value')
    const selectDocumentInstallation = getDefaultOptionByValue(dtInstallationsOptions, PRODUCTS_DATA.newProductMovements.installation, "value", "label", "value");
    let productTotals = useMemo(() => getSalesTotals(PRODUCTS_DATA.newProductMovements.products, SETTINGS), [PRODUCTS_DATA.newProductMovements.products]);
    let totalQuantity = productTotals.totalQuantity;
    let totalNetValue = productTotals.totalNetValue;
    let totalAmount = productTotals.totalAmount;
    let totalVatAmount = productTotals.totalVatValue;

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [productMovementsTableData, productsList])

    return (
        <React.Fragment>
            <div className="product-form position-relative">
                {disabledFields && <div className="overlay_w">{t('ProductsMovementsNew.message')}</div>}
                <Row>
                    <Col sm={12} md={3} className="showWithOverlay">
                        <Dropdown
                            label={t('ProductsMovementsNew.documentTypes')}
                            required={true}
                            name="documentType"
                            value={Object.keys(selectedDocumentType).length !== 0 ? selectedDocumentType : ''}
                            enabledValue={true}
                            options={documentTypesOptions}
                            onChange={(e) => handleOnChange(e, 'dd', 'documentType')}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={3}>
                        <Dropdown
                            label={t('ProductsMovementsNew.installation')}
                            name="installation"
                            value={Object.keys(selectDocumentInstallation).length !== 0 ? selectDocumentInstallation : ''}
                            enabledValue={true}
                            options={dtInstallationsOptions}
                            onChange={(e) => handleOnChange(e, 'dd', 'installation')}
                        />
                    </Col>
                    <Col sm={12} md={2}>
                        <Dropdown
                            label={t('ProductsMovementsNew.preNumber')}
                            name="preNumber"
                            key={Math.random()}
                            value={getDefaultOptionByValue(preNumberGreekOptions, PRODUCTS_DATA.newProductMovements.preNumber, 'value', 'label', 'value')}
                            enabledValue={true}
                            options={preNumberGreekOptions}
                            onChange={(e) => handleOnChange(e, 'dd', 'preNumber')}
                        />
                    </Col>
                    <Col sm="12" md="3">
                        <Input
                            key={Math.random()}
                            className="mb-3 w-100"
                            label={t('ProductsMovementsNew.number.number')}
                            charLimit={1000}
                            name="number"
                            type="number"
                            autoComplete="off"
                            value={PRODUCTS_DATA.newProductMovements.number}
                            placeholder={t('ProductsMovementsNew.number.placeholder')}
                            onChange={(e) => handleOnChange(e)}
                            disabled={disabledFields || PRODUCTS_DATA.newProductMovements.installationMode !== 'manual'}
                        />
                        {/* {PRODUCTS_DATA.isNumberExists} */}
                    </Col>
                    <Col sm="12" md="4">
                        <DateBox
                            classes="w-100 mb-3"
                            label={t('ProductsMovementsNew.date')}
                            name="date"
                            selected="today"
                            onChange={(e) => handleOnChange(e, 'dp', 'date')}
                        />
                    </Col>
                </Row>
                {(possibleInnerMovements.length > 1 && !docIsCensus) && (
                    <Row>
                        <Col md={3} className={"mb-3"}>
                            <Dropdown
                                name="innerMovement"
                                className={"mb-0"}
                                label={t('ProductsMovementsNew.innerMovement')}
                                key={Math.random()}
                                defaultValue={possibleInnerMovements?.filter((el) => el.value === PRODUCTS_DATA.newProductMovements.innerMovement)[0]}
                                options={[{
                                    label: "Κενό",
                                    value: ""
                                }].concat(possibleInnerMovements.filter((el) => el.value !== selectDocumentInstallation.value))}
                                onChange={(e) => handleOnChange(e, 'dd', 'innerMovement')}
                            />
                            <span className={"text-muted"}
                                  style={{margin: 0}}>{t('ProductsMovementsNew.innerMovementMessage')}</span>
                        </Col>
                    </Row>
                )}
                <Row>
                    <Col sm="12">
                        <Input
                            className="mb-3 w-100"
                            label={t('ProductsMovementsNew.reason.reason')}
                            name="reason"
                            autoComplete="off"
                            value={PRODUCTS_DATA.newProductMovements.reason}
                            onChange={(e) => handleOnChange(e)}
                            placeholder={t('ProductsMovementsNew.reason.placeholder')}
                        />
                    </Col>
                </Row>
                <hr className="mb-4"/>
                <Row>
                    <div className="et-table-ui">
                        {
                            ACTIVITY.saveNewProductMovements &&
                            productMovementsTableData &&
                            productMovementsTableData.length <= 0 &&
                            <div className="text-danger">{t('ProductsMovementsNew.table.required')}</div>
                        }
                        <EditableTable
                            tableName="Product Movements Products" // Do not change name
                            key={"Product Movements Products" + incrKey}
                            allowActions={true}
                            onUpdate={parentMydataActions}
                            allowInsertRow="true"
                            columns={productMovementColumns}
                            enableNewRowCheckbox={true}
                            data={productMovementsTableData}
                        />
                    </div>
                </Row>
                <hr/>
                <Row>
                    <Col sm="12" md="8"></Col>
                    <Col sm="12" md="4" className="d-flex justify-content-end">
                        <span className="mr-3 fw-bold">{t('SalesNew.totalsTable.title')}</span>
                        <table className="table table-bordered mb-3">
                            <tbody>
                            <tr>
                                <td className="fw-bold">{t('SalesNew.totalsTable.totalQuantity')}</td>
                                <td>{totalQuantity}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t('SalesNew.totalsTable.totalNetValue')}</td>
                                <td>{getGreekCurrencyFormat(totalNetValue)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t('SalesNew.totalsTable.totalVatAmount')}</td>
                                <td>{getGreekCurrencyFormat(totalVatAmount)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t('SalesNew.totalsTable.totalAmount')}</td>
                                <td>{getGreekCurrencyFormat(totalAmount)}</td>
                            </tr>
                            </tbody>
                        </table>
                    </Col>
                </Row>
                <Row>
                    <div style={{width: "100%"}}>
                        <div className="text-muted mb-2"><i>{t('ProductsMovementsNew.movementsNotes')}</i></div>
                        <TextArea
                            rows="4"
                            placeholder={t('ProductsMovementsNew.addMovementsNotes')}
                            name="notes"
                            autoComplete="off"
                            value={PRODUCTS_DATA.newProductMovements.notes}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </div>
                </Row>

            </div>
        </React.Fragment>
    )
}
